import { Typography } from "@mui/material";

export const CommonLabel = (props) => {
  const {
    label,
    color = "text.secondary",
    type = "common",
    fontSize = 11,
    bold = true,
    width = undefined,
    sx = {},
  } = props;
  if (type === "common") {
    return (
      <Typography
        variant="overline"
        fontWeight={bold ? "bold" : "normal"}
        noWrap
        sx={{
          width,
          color,
          fontSize,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.2", // 줄 간격 조정
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          ...sx,
        }}
      >
        {label}
      </Typography>
    );
  } else {
    return "not supported";
  }
};
